<div class="transitions-container" *ngIf="data">
    <ng-container *ngFor="let t of data.transitions">
        <div *ngIf="t.gateType" class="transition-row" [class.entry]="t.entra" [class.exit]="!t.entra">
            <button class="transition-btn" [style.background-color]="getBackColor(t.backcolor)"
                [style.color]="getForeColor(t.forecolor)">
                <i class="fa icon" [class.fa-sign-in]="t.entra" [class.fa-sign-out]="!t.entra"></i>
                <span class="transition-texts">
                    <span class="transition-caption">{{ t.caption }}</span>
                    <span class="transition-description" *ngIf="t.description">{{ t.description }}</span>
                </span>
            </button>
        </div>
        <div *ngIf="!t.gateType" class="transition-row transition">
            <button class="transition-btn" [style.background-color]="getBackColor(t.backcolor)"
                [style.color]="getForeColor(t.forecolor)">
                <i class="fa icon" [ngClass]="t.icon" *ngIf="t.icon"></i>
                <span class="transition-texts">
                    <span class="transition-caption">{{ t.caption }}</span>
                    <span class="transition-description" *ngIf="t.description">{{ t.description }}</span>
                </span>
            </button>
        </div>
    </ng-container>
</div>